import script from "./MainIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./MainIndex.vue?vue&type=script&setup=true&lang=js"

import "./MainIndex.vue?vue&type=style&index=0&id=3cf92e62&lang=css"

const __exports__ = script;

export default __exports__